import React from "react";
import { Card, Col } from "react-bootstrap";
import { Zoom } from "react-awesome-reveal";
import { Link } from "react-router-dom";

function OrderItemTile({ PageLink, Icon, title, statusList }) {
  return (
    <Col xs={6} className="mb-2 mb-lg-3 large-icons">
      <Zoom className="h-100">
        <Card className="text-center border-0 shadow-sm rounded-3">
          <Card.Body>
            <Link to={PageLink} state={{ statusList, title }}>
              {Icon}
              <div className="text-center pt-2 pb-2 text-dark fs-08">
                {title}
              </div>
            </Link>
          </Card.Body>
        </Card>
      </Zoom>
    </Col>
  );
}
export default OrderItemTile;
